import React, { Component } from 'react';

export default function (ComposedComponent) {

  class RequireAuthOrg extends Component {    
    state = {
      authToken: localStorage.getItem('authToken'),
      authRole: localStorage.getItem('authRole'),
    }

    // Push to login route if not authenticated on mount
    componentWillMount() {  
      // console.log(this.props);    
      if (!this.state.authToken) {
        this.props.history.push('/admin/login');
        // Use your router to redirect them to login page
      }
    }
    // http://192.168.1.11:3000
    // Push to login route if not authenticated on update
    componentWillUpdate(nextProps) {
      if (!this.state.authToken) {
        this.props.history.push('/admin/login');
        // Use your router to redirect them to login page
      }
    }

    // Otherwise render the original component
    render() {
      return <ComposedComponent {...this.props} />
    }
  }

  return RequireAuthOrg

}